module.exports = __webpack_public_path__ + "static/media/card_icon.53229380.png";